<script setup lang="ts">
import { checkoutPageUrl } from "~/utilities/urls"

const route = useRoute<"product">()
const productParam = computed(() => route.params.product)
const { isFeide } = useAuth()

const products = useProductVariantsStore()

const { data } = useEcommerceCatalogue()

const productPrice = computed(() => {
  const prices = getProductPrice(products.activeVariant, data)
  return prices?.actual ?? 0
})

const BuyButtonURL = computed(
  () =>
    `${checkoutPageUrl(productParam.value, {
      fromPath: `/produkter/${products.activeProduct?.urlFormatProductTitle}/${products.activeVariant?.variantKey}`,
      variant: products.activeVariant?.shortVariantLabel,
    })}`,
)
</script>

<template>
  <NuxtLink
    v-if="
      (productPrice > 0 &&
        products.activeVariant?.isReleased &&
        products.activeVariant.userHasLicence === false) && !isFeide
    "
    :to="BuyButtonURL"
    class="flex h-fit min-h-28 w-full items-center justify-center bg-[--theme-lighter] py-4"
  >
    <div
      class="flex w-[85%] max-w-[90em] items-center justify-between gap-4 font-national2 text-2xl text-[--theme-darker] 2xl:text-3xl"
    >
      <h2
        class="line-clamp-3 max-w-[45%] md:line-clamp-1 md:max-w-[85%] lg:max-w-3/4"
      >
        <span class="hidden xl:inline">
          Forstå faget og bestå eksamen med Kunne
        </span>
        <span class="xl:hidden">Kunne </span>
        <b>{{ productPrice }},-</b>
        for hele semesteret
      </h2>
      <UButton
        class="md:hidden"
        variant="filled"
        theme="cta"
        pill
        size="lg"
        data-pendo="banner-kjop-tilgang"
        :to="BuyButtonURL"
      >
        Kjøp
        <span class="sr-only">
          tilgang til Kunne {{ productParam }}</span>
      </UButton>
      <UButton
        class="hidden md:block"
        variant="filled"
        theme="cta"
        pill
        size="lg"
        :to="BuyButtonURL"
        data-pendo="banner-kjop-tilgang"
      >
        Kjøp tilgang
        <span class="sr-only"> til Kunne {{ productParam }}</span>
      </UButton>
    </div>
  </NuxtLink>
</template>
